import React from "react";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";

const AnimatedTitle = ({
  children,
  tag: Tag = "h2",
  className = "",
  animation = "fadeInUp",
  delay = 0,
  ...rest
}) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <Tag
      ref={ref}
      className={`${className} ${
        isVisible ? `animate-${animation}` : "opacity-0"
      }`}
      style={isVisible ? { animationDelay: `${delay}ms` } : {}}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default AnimatedTitle;
